import React, { Component } from "react";
import "./Navbar.css";
import { withFirebase } from "./Firebase";
import { withRouter } from "react-router-dom";
import * as ROUTES from '../constants/routes';
import userProfilImage from './assets/icon_user_profile.svg'
import speedmeter from './assets/speedometer.png';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';

class Navbar extends Component {
  render() {
    let width = window.innerWidth;
    if (width > 768) {
      return (
        <NavbarB />
      );
    } else {
      return (
        <NavbarPhone />
      );
    }
  }
}
const INITIAL_STATE = {
  users: null,
  companies: null,
  current_user: null,
  image_user: null,
  home: null,
  search: null,
  pilotage: null,
  account: null,
  company: { name: "", logo: "" },
  openSnackUpdate: false,
};

class NavbarBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, isSelect: [], };
  }

  componentDidMount() {
    window['isUpdateAvailable']
      .then(isAvailable => {
        if (isAvailable) {
          this.setState({ openSnackUpdate: true })
        }
        else {
          console.info("NO version available")
        }
      });


    let uid;
    this.props.firebase.auth.onAuthStateChanged(async (user) => {
      if (user === null) {
        return
      }
      let cu;
      uid = user.uid
      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            cu = doc.data();
            this.setState({ current_user: cu, image_user: doc.data().image_url_profile });
          } else {
            console.error("No such document!");
          }
        })
        .then(() => {
          this.props.firebase.db
            .collection("companies")
            .doc(cu.company)
            .get()
            .then((doc) => {
              if (doc.exists) {
                const company = doc.data();
                this.setState({ company: company });
              } else {
                console.error("No such document!");
              }
            })
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });
    });
  }

  myRoutes = (route) => {

    var Select = {
      backgroundColor: "rgba(255, 255, 255, 0.28)",
    };

    switch (route) {
      case 'home':
        {
          this.setState({ home: Select, account: null, pilotage: null, search: null });
          return this.props.history.push(ROUTES.HOME)
        }
      case 'account': {
        this.setState({ home: null, account: Select, pilotage: null, search: null });
        return this.props.history.push(ROUTES.ACCOUNT);
      }
      case 'driving': {
        this.setState({ home: null, account: null, pilotage: Select, search: null });
        return this.props.history.push(ROUTES.DRIVING);
      }
      case 'search': {
        this.setState({ home: null, account: null, pilotage: null, search: Select });
        return this.props.history.push(ROUTES.SEARCH);
      }
      default:
        return null;
    }
  }

  onRefresh = () => {
    window.location.reload(window.location.href);
  };

  render() {
    const {
      home, search, pilotage, account,
      image_user,
      company,
    } = this.state;
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-light bg-light custom-nav">
          <div className="navbar-collapse sizing-bar">
            <div onClick={() => this.myRoutes('home')} style={home} className="text-center cursor-pointer select-blue">
              <img src={require("./assets/icon_home.svg")} alt="profile" />
              <span className="nav-link-bis">Accueil</span>
            </div>
            <div onClick={() => this.myRoutes('account')} style={account} className="text-center cursor-pointer select-blue padding-select">
              <img
                className="profile-picture margin-top-nav-7"
                src={image_user !== null ? image_user : userProfilImage}
                alt="profile"
                onError={this.props.firebase.profileImgError}
              />
              <span className="nav-link-bis mb-1" href="#">
                Mon compte
                </span>
            </div>
            <div onClick={() => this.myRoutes('driving')} style={pilotage} className="text-center select-blue cursor-pointer">
              <img
                src={speedmeter}
                alt="profile"
              />
              <span className="nav-link-bis margin-top-nav-2" href="#">
                Pilotage
                </span>
            </div>
            <div style={search} onClick={() => this.myRoutes('search')} className="text-center select-blue cursor-pointer">
              <img
                src={require("./assets/icon_search.svg")}
                alt="profile"
                href={"/recherche"}
              />
              <span className="nav-link-bis margin-top-nav-1" href="#">
                Recherche
                </span>
            </div>
          </div>
          <div>
            <div className="text-center padding-compagny">
              <span className="nav-link-compagny mr-3" href="#">
                {company.name}
              </span>
              <img
                className="picture-compagny"
                src={company.logo !== null ? company.logo : userProfilImage}
                alt="profile"
                onError={this.props.firebase.profileImgError}
              />
            </div>
          </div>
        </nav>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.state.openSnackUpdate}
          autoHideDuration={null}
          onClose={this.handleClose}
          message={<span id="message-id">Nouvelle version disponible</span>}
          action={
            <Button color="inherit" size="small" onClick={this.onRefresh}>
              Refresh
            </Button>
          }
        />
      </div>
    );
  }
}

class NavbarBasePhone extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, click: true }
  }

  componentDidMount() {
    window['isUpdateAvailable']
      .then(isAvailable => {
        if (isAvailable) {
          console.info("new version available")
          this.setState({ openSnackUpdate: true })
        }
        else {
          console.error("NO version available")
        }
      });

    let uid;
    this.props.firebase.auth.onAuthStateChanged(async (user) => {
      if (user === null) {
        return
      }
      let cu;
      uid = user.uid
      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            cu = doc.data();
            this.setState({ current_user: cu, image_user: doc.data().image_url_profile });
          } else {
            console.error("No such document!");
          }
        })
        .then(() => {
          this.props.firebase.db
            .collection("companies")
            .doc(cu.company)
            .get()
            .then((doc) => {
              if (doc.exists) {
                const company = doc.data();
                this.setState({ company: company });
              } else {
                console.error("No such document!");
              }
            })
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });
    });
  }

  onNavigation = () => {
    const { click } = this.state
    if (click === false) {
      this.setState({ click: true })
    } else {
      this.setState({ click: false })
    }
  }

  myRoutes = (route) => {
    this.setState({ click: !this.state.click })
    switch (route) {
      case 'home':
        return this.props.history.push(ROUTES.HOME);
      case 'account':
        return this.props.history.push(ROUTES.ACCOUNT);
      case 'driving':
        return this.props.history.push(ROUTES.DRIVING);
      case 'search':
        return this.props.history.push(ROUTES.SEARCH);
      default:
        return null;
    }
  }

  onRefresh = () => {
    window.location.reload(window.location.href);
  };

  render() {
    const { click, company } = this.state;

    return (
      <div className="padding-safe-area">
        <div className="pos-f-t margin-hidden-nav">
          <div className="pos-fixe">
            <nav className="navbar navbar-dark navbar-phone">
              <button
                className="navbar-toggler dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={this.onNavigation}
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div>
                <div className="text-center">
                  <span className="nav-link-compagny mr-3" href="#">
                    {company.name}
                  </span>
                  <img
                    className="picture-compagny"
                    src={company.logo !== null ? company.logo : userProfilImage}
                    alt="profile"
                    onError={this.props.firebase.profileImgError}
                  />
                </div>
              </div>
            </nav>
            <div hidden={click}>
              <div onClick={() => this.myRoutes('home')} className="text-center navbarPhone ">
                <span className="text-white">Accueil</span>
              </div>
              <div onClick={() => this.myRoutes('account')} className="text-center navbarPhone ">
                <span className="text-white">Mon compte</span>
              </div>
              <div onClick={() => this.myRoutes('driving')} className="text-center navbarPhone ">
                <span className="text-white">Pilotage</span>
              </div>
              <div onClick={() => this.myRoutes('search')} className="text-center navbarPhone ">
                <span className="text-white">Recherche</span>
              </div>
            </div>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.state.openSnackUpdate}
          autoHideDuration={null}
          onClose={this.handleClose}
          message={<span id="message-id">Nouvelle version disponible</span>}
          action={
            <Button color="inherit" size="small" onClick={this.onRefresh}>
              Refresh
            </Button>
          }
        />
      </div>
    );
  }
}

const NavbarB = withRouter(withFirebase(NavbarBase));
const NavbarPhone = withRouter(withFirebase(NavbarBasePhone));

export { NavbarB, NavbarPhone };
export default Navbar;
